import store from '@ps/store'
import _ from 'lodash'
import { language } from '@/common/storage'
import i18n from '@ps/lang'
import { VpBaseMethods } from '@ps/bridge/qc/vp/config'
import { getVpAstFromSceneNode } from '@ps/bridge/qc/vp'

export function getVpSendAction() {
  const sceneList = store.state.workspace.game.sceneManager.sceneList
  let astList = []
  sceneList.forEach((scene) => {
    astList = astList.concat(getVpAstFromSceneNode(scene))
  })
  // const astList = store.state.workspace.game.visualProgram.ast || []
  const vpSendActionList: any[] = []
  astList.forEach((item) => {
    if (item.action) {
      item.action.forEach((action) => {
        if (action.method === VpBaseMethods.vpSendAction) {
          vpSendActionList.push(action)
        }
      })
    }
  })
  return vpSendActionList
}

export function cookActionForActionName(action, isNewAction) {
  if (action.method === VpBaseMethods.vpSendAction) {
    if (isNewAction) {
      action.param.initData.action_id = getAvailableActionId()
    }
    // 获取埋点名称
    action.param.initData.action_name = getActionName(
      action.param.initData.action_id,
    )
    const options = []
    for (let i = 1; i <= 15; i++) {
      options.push({
        label: i,
        value: i,
      })
    }
    action.param.properties.action_name = {
      title: i18n.t(
        `workbench.eventSetting.action.${VpBaseMethods.vpSendAction}.paramFormConfig.action_name.title`,
      ),
      component: 'input',
      field: {},
    }
    // 埋点id配置方式修改为select，增加1-15埋点option
    action.param.properties.action_id = {
      ...action.param.properties.action_id,
      component: 'select',
      field: {
        ...action.param.properties.action_id.field,
        options,
      },
    }
  }
  return action
}

export function getActionNameInitData(data) {
  const temp: any = {}
  temp.action_name = getActionName(data.action_id)
  return temp
}

export function getActionName(actionId) {
  const actions = store.state.workspace.project.info.actions || {}
  const actionPre = language.get() === 'en' ? 'action' : '埋点'
  return actions[`action${actionId}`] || `${actionPre}${actionId}`
}

export function getActionInitData(action, data) {
  let tempParam
  if (action && action.param) {
    tempParam = _.cloneDeep(action.param)
  } else {
    // tempParam = _.cloneDeep(action.param.initData)
  }
  if (action.method === VpBaseMethods.vpSendAction) {
    return {
      ...data,
      ...getActionNameInitData(tempParam),
    }
  }
  return data
}

export function getNewActionInitData(action, data) {
  const temp = getActionInitData(action, data)
  if (action.method === VpBaseMethods.vpSendAction) {
    temp.action_id = getAvailableActionId()
    return temp
  }
  return data
}

// 获取当前设置埋点名称映射
export function getCurrentActionName() {
  const vpSendActionList = getVpSendAction()
  const actions = store.state.workspace.project.info.actions || {}
  const nameMap: any = {}
  vpSendActionList.forEach((action) => {
    const key = `action${action.paramLabelUI}`
    if (actions[key]) {
      nameMap[key] = actions[key]
    }
  })
  return nameMap
}

// 获取可用id
export function getAvailableActionId() {
  const vpSendActionList = getVpSendAction()
  const defaultIds = [] // 默认id列表
  for (let i = 1; i <= 15; i++) {
    defaultIds.push(i)
  }
  const settingIds = _.uniq(vpSendActionList.map((item) => item.paramLabelUI))
  // 获取未设置id列表
  const availableIds = defaultIds.filter((id) => !settingIds.includes(id))
  // 如果存在可用id，返回第一个可用id，如果不存在可用id，返回默认id值最后一个
  if (availableIds.length) {
    return availableIds[0]
  }
  return defaultIds[defaultIds.length - 1]
}
